import { ReactNode, useMemo } from "react";
import { Button, Grid, ButtonProps } from "@mui/material";
import MxDetailSmallCard from "./MxDetailCardSmall";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";

export interface MxDetailPanelActionItem {
  label: string;
  onClick?: () => void;
  icon?: ReactNode;
  show?: boolean;
}

export interface MxDetailPanelActionButton extends ButtonProps {
  label: string;
  onClick?: () => void;
  show?: boolean;
  startIcon?: ReactNode;
}

export interface MxDetailPanelActionProps {
  title?: string;
  actions: MxDetailPanelActionItem[];
  buttonsActions?: MxDetailPanelActionButton[];
}

const MxDetailPanelAction = ({
  title = "Panel de acciones",
  actions,
  buttonsActions = []
}: MxDetailPanelActionProps) => {
  const computedActions = useMemo(
    () =>
      actions
        .filter(action => Boolean(action))
        .map((action, index) => ({
          key: `${action.label}-${index}`,
          config: action
        })),
    [actions]
  );

  const computedButtons = useMemo(
    () =>
      buttonsActions
        .filter(button => button.show !== false)
        .map((button, index) => ({
          key: `${button.label}-${index}`,
          config: button
        })),
    [buttonsActions]
  );

  if (!computedActions.length && !computedButtons.length) return null;

  return (
    <MxDetailSmallCard title={title}>
      <Grid container direction="column" rowGap={1.5}>
        {computedActions.map(({ key, config }) => (
          <Grid
            item
            key={key}
            container
            alignItems="center"
            gap={1.5}
            sx={{ cursor: "pointer" }}
            onClick={config.onClick}
          >
            <MxIcons sx={{ color: "primary.main" }}>{config.icon}</MxIcons>
            <MxTypography variant="overline" color="text.primary" fontWeight={400}>
              {config.label}
            </MxTypography>
          </Grid>
        ))}

        {computedButtons.length > 0 && (
          <Grid
            container
            direction="row"
            gap={1.5}
            mt={1}
            justifyContent="space-between"
          >
            {computedButtons.map(({ key, config }) => {
              const { label, show, ...buttonProps } = config;
              return (
                <Button key={key} size="medium" {...buttonProps}>
                  {label}
                </Button>
              );
            })}
          </Grid>
        )}
      </Grid>
    </MxDetailSmallCard>
  );
};

export default MxDetailPanelAction;
